import termsAndAgreementStyles from './terms-and-agreement';